const isValidEmail = (email: string): string => {
  const match = email
    .trim()
    .toLowerCase()
    .replace(/\s/g, '')
    .match(/([a-z0-9._!#$%+^&*()[\]<>-]+)@[a-z0-9._-]+\.[a-z0-9._-]+/i);
  return match ? match[0] : '';
};

type FreestarIdentityApi = {
  setIdentity?: (payload: { email: string } | { hashes: Record<string, string> }) => void;
  clearIdentity?: () => void;
};

export const passFreestarIdentity = (userEmail?: string | null): void => {
  if (typeof window === 'undefined') return;

  const freestar = (window.freestar ??= {});
  const queue = (freestar.queue ??= []);
  const validUserEmail = userEmail ? isValidEmail(userEmail) : '';

  queue.push(() => {
    const identity = freestar.identity as FreestarIdentityApi | undefined;
    if (!validUserEmail) {
      identity?.clearIdentity?.();
      return;
    }
    identity?.setIdentity?.({ email: validUserEmail });
  });
};
